<template>
  <div ref="body">
     <custom-header active="global" :subActive="current"></custom-header>
    
    <div class="content-container">
      <h1 class="text-bold" style="margin:50px;">Privacy Policy</h1>
      <p style="font-size: 20px;">Shenzhen Dezong Exhibition Co., Ltd.  is engaged in Smart Home & Creative Furniture Exhibition Platform. We attach the utmost importance to the security of customer and supplier information. This page sets forth our policies with respect to the protection of personal information.</p>
      <p style="font-size: 20px;margin-top: 10px;"><b>1. Compliance with Laws and Other Regulations</b></p>
      <p style="font-size: 20px;">We comply with all national laws and policies and other regulations relating to the protection of personal information.</p>
      <p style="font-size: 20px;margin-top: 10px;"><b>2. Establishment and Continuous Enhancement of Personal Information Handling Guidelines</b></p>
      <p style="font-size: 20px;">The need to protect personal information is thoroughly promulgated throughout the company, from directors down to the most junior employees. We maintain and follow guidelines for the proper protection and use of personal information. We also strive to improve these guidelines on a continuing basis.</p>
      <p style="font-size: 20px;margin-top: 10px;"><b>3. Acquisition, Use and Release of Personal Information</b></p>
      <p style="font-size: 20px;">We clearly define the uses to which personal information can be put. Within these constraints, we acquire, use and release personal information only with the consent of the individual concerned.</p>
      <p style="font-size: 20px;margin-top: 10px;"><b>4. Secure Management</b></p>
      <p style="font-size: 20px;"> We strive to maintain secure management of personal information, and have established the necessary measures to prevent unauthorized data access, loss, destruction, alteration or leaking.</p>
      <p style="font-size: 20px;margin-top: 10px;"><b>5. Disclosure and Correction</b></p>
      <p style="font-size: 20px;">Requests for disclosure, editing or deletion of personal information shall be responded to on a case by case basis pending confirmation of the identity of the requestor.</p>
      <p style="font-size: 20px;">*Please direct any queries concerning personal data to Shenzhen Dezong Exhibition Co., Ltd.  General Affairs Division.</p>
    </div>
    
    <custom-footer :friendLink="friendLink"></custom-footer>
    
    <!-- 回到顶部 -->
    <scroll-top @scrollTop="scrollTop"></scroll-top>
    
  </div>
</template>

<script>
import { Swipe, SwipeItem, Icon } from 'vant';
import customHeader from "./components/head.vue";
import customFooter from "./components/foot.vue";
import scrollTop from "./components/scrollTop.vue";
import commonMixin from './commonMixin.js';

export default {
  // name: '展会介绍',
  components: {
    'custom-header': customHeader,
    'custom-footer': customFooter,
    'scroll-top': scrollTop,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  mixins: [commonMixin],
  metaInfo: {
    title: 'Shenzhen Creative Week: About the World Furniture Fair', // set a title
    meta: [
      { name: 'keyWords', content: 'Furniture Fair,Home Design,Furniture Exhibitor,Home Furnishing Forum,Design Week,Home Design Week'},
      { name: 'description', content: 'SZ Creative Week is Held Annually for Sourcing Furniture & Home Interior Products. This Design Exhibition in China is Organized By Shenzhen Furniture Association.'},
    ],
  },
  data() {
    return {
      current: 'intro',
    }
  },
  created() {

  },
  destroyed () {
    let videoElement = document.querySelector('#my-video');
    if (videoElement) {
      // 销毁 VIDEO 元素
      videoElement.pause(); // 停止播放
      videoElement.removeAttribute('src'); // 清空srcs属性来停止加载
      videoElement.load(); // 调用 load() 方法，以确保所有相关数据都被卸载。
      // 将 VIDEO 元素的事件监听器设为 null，以避免内存泄漏。
      videoElement.oncanplaythrough = null;
      videoElement.onerror = null;
      videoElement.remove();
      videoElement = null; // 最后将 VIDEO 元素赋值为 null，以释放其占用的内存。
    }
  },
  methods: {

  },
}
</script>

<style scoped lang="less">

// 移动端
@media screen and (max-width: 1023px) {
  .content-container {
    width: 100%;
    padding: 20px;
    
    h1 {
      font-size: 18px;
      text-align: center;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 15px;
      text-align: center;
      margin: 16px 0;
    }
    
    .video-container {
      width: 100%;
      height: 190px;
      background-color: #fff;
      border-radius: 3px;
      overflow: hidden;
      margin: 20px 0;
    }
    
    .section {
      margin: 10px 0;
    }
    .p4 {
      font-size: 13px;
      line-height: 2em;
      // text-align: justify;
      margin: 0 0 4px;
    }
    
    .theme-intro-box {
      font-size: 14px;
      line-height: 2em;
      
      li {
        list-style-type: disc;
        list-style-position: outside;
        margin-left: 8px;
        margin-bottom: 8px;
      }
    }
  }
}

// pc
@media screen and (min-width: 1024px) {
  
  .banner-container {
    width: 100%;
    
    .banner {
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }
  .content-container {
    width: 190px;
    margin: 15px auto 20px;
    
    h1 {
      font-size: 6px;
      text-align: center;
    }
    h2 {
      width: 155px;
      margin: 0 auto;
      font-size: 6px;
      text-align: center;
    }
    
    .video-container {
      width: 100%;
      height: 107px;
      background-color: #fff;
      border-radius: 2px;
      overflow: hidden;
      margin: 5px 0;
    }
    
    .section {
      margin: 10px 0;
    }
    
    .p4 {
      font-size: 3.6px;
      line-height: 1.8em;
      text-align: justify;
      margin: 0 0 4px;
    }
    
    .theme-intro-box {
      font-size: 3.6px;
      line-height: 2em;
      
      li {
        list-style-type: disc;
        list-style-position: outside;
        margin-left: 8px;
        margin-bottom: 2px;
      }
    }

  }
}

</style>